import React, { useCallback } from 'react';

import styled, { css } from 'styled-components';

import { mobile, mobileDevice } from '../../styles';
import { Component as Bounceback } from '../Bounceback';
import { CartUpsellCarousel } from '../CartUpsellCarousel';
import BottomSheet from '../FilterDrawerV2/BottomSheet';
import { Component as NewPricingSkinnyBanner } from '../NewPricingSkinnyBanner';
import QuickViewModal from '../QuickViewModal/QuickViewModal';
import SpinningLoader from '../SpinningLoader/SpinningLoader';
import { Component as StyleContext } from '../StyleContext';

import { CartDrawerBasketItemList } from './CartDrawerBasketItemList';
import { CartDrawerHeaderTitleMessage } from './CartDrawerHeaderTitleMessage';
import { CartDrawerInfluencerToastMessage } from './CartDrawerInfluencerToastMessage';
import { CartDrawerBody, Content } from './CartDrawerWrapper';
import { NewCartDrawerFreeShippingProgressBar } from './NewCartDrawerFreeShippingProgressBar';
import { NewCartDrawerMemberCreditsToggle } from './NewCartDrawerMemberCreditsToggle';
import { NewCartDrawerPromoProgressBar } from './NewCartDrawerPromoProgressBar';
import { useDrawerState } from './useDrawerState';
import { useOpenMobileCartDrawerRef } from './useOpenMobileCartDrawerRef';
import { useShowShoppingBagLoadingIndicator } from './useShowShoppingBagLoadingIndicator';
import { useVisibility } from './useVisibility';

const contentWrapperStyling = css`
  width: 100%;
  height: 'auto';

  ${mobileDevice`
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 100%;
    justify-content: space-between;
  `}
`;

const bottomSheetStyling = {
  closeIconStyling: css`
    stroke: ${({ theme }) => theme.colors.black};
  `,
  headerStyling: css`
    border: none;
  `,
  contentStyling: css`
    ${mobile`padding: ${({ theme }) => theme.spacing.small}px 0;`}
  `,
};

const ExpandedFooterWrapper = styled.div`
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;

  ${mobile`
    padding: 0 ${({ theme }) => theme.spacing.small}px;
  `}
`;

const SpinningLoaderWrapper = styled.div`
  ${SpinningLoader.SpinnerWrapper} {
    top: 64px;
    height: calc(100% - 64px);
  }
`;

const PROMO_BAR_UPDATED = false;

export function NewCartDrawerMobileRenderer({
  collapsableFooter,
  expandedFooter,
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useDrawerState();
  const closeDrawer = useCallback(
    () => setIsDrawerOpen(false),
    [setIsDrawerOpen]
  );

  const sheetRef = useOpenMobileCartDrawerRef();
  const { divRef: expandedFooterRef, isVisible: isExpandedFooterVisible } =
    useVisibility({});
  const { showLoadingIndicator } = useShowShoppingBagLoadingIndicator();

  return (
    <BottomSheet
      onClose={closeDrawer}
      title={<CartDrawerHeaderTitleMessage />}
      footer={collapsableFooter}
      enableFooterAnimations={isDrawerOpen}
      hideCollapsableFooter={isExpandedFooterVisible}
      detente={0.95}
      ref={sheetRef}
      styles={bottomSheetStyling}
      showToastMessages
      showHeaderSeparator
      contentPadding={0}
    >
      <StyleContext context="cartDrawer">
        <Content contentWrapperStyling={contentWrapperStyling}>
          <SpinningLoaderWrapper>
            {showLoadingIndicator && (
              <SpinningLoader
                isLoading
                height={24}
                width={24}
                shouldFadeBackground
                color="#1c1b1f"
              />
            )}
          </SpinningLoaderWrapper>
          <NewPricingSkinnyBanner />
          <Bounceback shouldShowTerms={false} />
          <NewCartDrawerFreeShippingProgressBar />
          <NewCartDrawerMemberCreditsToggle />
          {PROMO_BAR_UPDATED && <NewCartDrawerPromoProgressBar />}
          <CartDrawerBody>
            <CartDrawerInfluencerToastMessage />
            <CartDrawerBasketItemList />
            <CartUpsellCarousel />
          </CartDrawerBody>
          <ExpandedFooterWrapper ref={expandedFooterRef}>
            {expandedFooter}
          </ExpandedFooterWrapper>
        </Content>
        <QuickViewModal />
      </StyleContext>
    </BottomSheet>
  );
}
